(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aura-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const moneyText = (option) => option?.dataset.price || '';
    document.querySelectorAll('[data-aura-section]').forEach((section) => {
      const variantSelect = section.querySelector('[data-aura-variant-select]');
      const price = section.querySelector('[data-aura-price]');
      const addButton = section.querySelector('[data-aura-add]');
      const addText = section.querySelector('[data-aura-add-text]');
      const stickyPrice = section.querySelector('[data-aura-sticky-price]');
      const stickyLabel = section.querySelector('[data-aura-sticky-label]');
      const stickyAdd = section.querySelector('[data-aura-sticky-add]');
      let color = variantSelect?.selectedOptions[0]?.dataset.color || '';
      let pack = variantSelect?.selectedOptions[0]?.dataset.pack || '';

      const allVariantOptions = () => Array.from(variantSelect?.options || []);
      const optionButtons = (kind) => Array.from(section.querySelectorAll('[data-aura-option="' + kind + '"]'));

      const syncButtons = () => {
        optionButtons('color').forEach((button) => {
          const active = button.dataset.value === color;
          button.classList.toggle('is-selected', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        optionButtons('pack').forEach((button) => {
          const active = button.dataset.value === pack;
          button.classList.toggle('is-selected', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
          const matching = allVariantOptions().find((option) => option.dataset.color === color && option.dataset.pack === button.dataset.value);
          const packPrice = button.querySelector('.aura-pack__price');
          if (packPrice && matching) packPrice.textContent = moneyText(matching);
        });
        section.querySelectorAll('[data-aura-gallery-finish]').forEach((button) => {
          button.classList.toggle('is-selected', button.dataset.value === color);
        });
      };

      const syncVariant = () => {
        if (!variantSelect) return;
        let target = allVariantOptions().find((option) => option.dataset.color === color && option.dataset.pack === pack);
        if (!target) target = allVariantOptions().find((option) => option.dataset.color === color);
        if (!target) return;
        pack = target.dataset.pack;
        variantSelect.value = target.value;
        const available = target.dataset.available === 'true';
        if (price) price.textContent = moneyText(target);
        if (stickyPrice) stickyPrice.textContent = moneyText(target);
        if (stickyLabel) stickyLabel.textContent = color + ' · ' + pack;
        if (addButton) addButton.disabled = !available;
        if (stickyAdd) stickyAdd.disabled = !available;
        if (addText) addText.textContent = available ? 'Add to cart' : 'Sold out';
        if (stickyAdd) stickyAdd.textContent = available ? 'Add to cart' : 'Sold out';
        syncButtons();
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      };

      optionButtons('color').forEach((button) => button.addEventListener('click', () => {
        color = button.dataset.value;
        syncVariant();
      }));
      optionButtons('pack').forEach((button) => button.addEventListener('click', () => {
        pack = button.dataset.value;
        syncVariant();
      }));
      section.querySelectorAll('[data-aura-gallery-finish]').forEach((button) => button.addEventListener('click', () => {
        color = button.dataset.value;
        syncVariant();
        section.querySelector('.aura-buybox')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }));
      section.querySelector('[data-aura-pair-select]')?.addEventListener('click', () => {
        pack = 'Set of 2';
        syncVariant();
        section.querySelector('.aura-buybox')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      section.querySelector('[data-aura-scroll-buy]')?.addEventListener('click', () => section.querySelector('.aura-buybox')?.scrollIntoView({ behavior: 'smooth', block: 'center' }));
      stickyAdd?.addEventListener('click', () => {
        if (!stickyAdd.disabled) addButton?.click();
      });

      const hero = section.querySelector('.aura-gallery__hero');
      section.querySelectorAll('[data-aura-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
        if (!hero) return;
        section.querySelectorAll('[data-aura-thumb]').forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
        hero.style.opacity = '0';
        window.setTimeout(() => {
          hero.src = thumb.dataset.src;
          hero.alt = thumb.dataset.alt || '';
          hero.style.opacity = '1';
        }, 120);
      }));

      syncVariant();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
